module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _vm._l((_vm.attributes), function(attribute, index) {
    return (attribute.id !== 'SELLER_SKU' && attribute.id !== 'SIZE_GRID_ROW_ID') ? _c('form-group', {
      key: attribute,
      attrs: {
        "label": attribute.name,
        "columns": 4,
        "required": attribute.tags && attribute.tags.required || attribute.attributeUsedAsVariation,
        "error": _vm.getError(attribute.id, _vm.errorIndex)
      }
    }, [(_vm.isSelectWithId(attribute) && Object.keys(_vm.custom).indexOf(attribute.id) === -1) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.id]),
        expression: "product.attributes[attribute.id]"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.product.attributes, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.onChangeAttribute(attribute.id, _vm.product.attributes[attribute.id])
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.values), function(attributeValue) {
      return _c('option', {
        key: attributeValue,
        domProps: {
          "value": attributeValue.id
        }
      }, [_vm._v(_vm._s(attributeValue.name))])
    })], 2) : (_vm.isSelectWithId(attribute) && Object.keys(_vm.custom).indexOf(attribute.id) !== -1) ? _c('div', [(!_vm.custom[attribute.id]) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.id]),
        expression: "product.attributes[attribute.id]"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.product.attributes, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.onChangeAttribute(attribute.id, _vm.product.attributes[attribute.id])
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _c('optgroup', {
      attrs: {
        "label": _vm.$t(("custom." + (attribute.id.toLowerCase()) + ".label"))
      }
    }, [(Object.keys(_vm.custom).indexOf(attribute.id) !== -1) ? _c('option', {
      attrs: {
        "value": "custom"
      }
    }, [_vm._v("Adicionar personalizada")]) : _vm._e(), _vm._v(" "), _vm._l((attribute.values), function(attributeValue) {
      return (attributeValue.custom) ? _c('option', {
        key: attributeValue,
        domProps: {
          "value": attributeValue.id
        }
      }, [_vm._v(_vm._s(attributeValue.name))]) : _vm._e()
    })], 2), _vm._v(" "), _c('optgroup', {
      attrs: {
        "label": _vm.$t(("default." + (attribute.id.toLowerCase()) + ".label"))
      }
    }, _vm._l((attribute.values), function(attributeValue) {
      return (!attributeValue.custom) ? _c('option', {
        key: attributeValue,
        domProps: {
          "value": attributeValue.id
        }
      }, [_vm._v(_vm._s(attributeValue.name))]) : _vm._e()
    }), 0)]) : _c('span', [_c('editable', {
      attrs: {
        "value": "",
        "isEditable": true,
        "onConfirm": function (a, b) { return _vm.onConfirmAttribute(a, b, attribute.id); },
        "onCancel": function () { return _vm.onCancelAttribute(attribute.id); }
      }
    })], 1)]) : (!attribute.default_unit && attribute.id !== 'SIZE_GRID_ID') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.id]),
        expression: "product.attributes[attribute.id]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": attribute.id === 'EAN' && _vm.typeCheckout
      },
      domProps: {
        "value": (_vm.product.attributes[attribute.id])
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAttribute(attribute.id, _vm.product.attributes[attribute.id])
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.product.attributes, attribute.id, $event.target.value)
        }
      }
    }) : (attribute.id === 'SIZE_GRID_ID') ? _c('select', {
      staticClass: "form-select"
    }, [_c('option', [_vm._v("Selecione a Guia de Medidas")])]) : _c('div', {
      staticClass: "form-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.id]),
        expression: "product.attributes[attribute.id]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product.attributes[attribute.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.product.attributes, attribute.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-addon"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.default_unit),
        expression: "attribute.default_unit"
      }],
      staticClass: "form-select form-select--sm",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "default_unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((attribute.allowed_units), function(unit) {
      return _c('option', {
        domProps: {
          "value": unit.id
        }
      }, [_vm._v(_vm._s(unit.name))])
    }), 0)])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633513b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/general/Attributes.vue
// module id = 3229
// module chunks = 0